<div [attr.data-qa]="successContainerQaId?.baseId">
  <ng-container #container></ng-container>
</div>

<div #checkMark>
  <div
    *ngIf="checkMarkContainer"
    class="d-flex justify-content-center align-items-center mt-5 mt-md-13"
  >
    <app-svg iconName="Check" dimension="1.5rem"></app-svg>
  </div>
</div>
